export default {"src":"/_next/static/media/speechmark_148.99b064a4.svg","height":148,"width":148};